/**
 *
 * Asynchronously loads the component for RequestFiles
 *
 */

import { lazyLoad } from 'utils/loadable';

export const RequestFiles = lazyLoad(() => import('./index'));
